"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var FaqSupportTicketController = /** @class */ (function () {
    function FaqSupportTicketController(requestFormService) {
        this.requestFormService = requestFormService;
        this.isSubmitting = false;
        this.hasError = false;
        this.isFormValid = true;
        this.isSubmitted = false;
    }
    FaqSupportTicketController.prototype.submit = function () {
        var _this = this;
        this.isSubmitted = false;
        if (!this.form.$valid) {
            this.isFormValid = false;
            return;
        }
        this.isFormValid = true;
        this.isSubmitting = true;
        this.requestFormService.createTicket(this.model).then(function () {
            _this.isSubmitted = true;
            _this.hasError = false;
        }).catch(function () {
            _this.hasError = true;
        }).finally(function () {
            _this.isSubmitting = false;
        });
    };
    return FaqSupportTicketController;
}());
exports.FaqSupportTicketController = FaqSupportTicketController;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZmFxU3VwcG9ydFRpY2tldC5jb250cm9sbGVyLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiZmFxU3VwcG9ydFRpY2tldC5jb250cm9sbGVyLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7O0FBRUE7SUFRSSxvQ0FBb0Isa0JBQXVCO1FBQXZCLHVCQUFrQixHQUFsQixrQkFBa0IsQ0FBSztRQVBwQyxpQkFBWSxHQUFHLEtBQUssQ0FBQztRQUNyQixhQUFRLEdBQUcsS0FBSyxDQUFDO1FBQ2pCLGdCQUFXLEdBQUcsSUFBSSxDQUFDO1FBQ25CLGdCQUFXLEdBQUcsS0FBSyxDQUFDO0lBSW1CLENBQUM7SUFFeEMsMkNBQU0sR0FBYjtRQUFBLGlCQWtCQztRQWpCRyxJQUFJLENBQUMsV0FBVyxHQUFHLEtBQUssQ0FBQztRQUN6QixJQUFJLENBQUMsSUFBSSxDQUFDLElBQUksQ0FBQyxNQUFNLEVBQUU7WUFDbkIsSUFBSSxDQUFDLFdBQVcsR0FBRyxLQUFLLENBQUM7WUFDekIsT0FBTztTQUNWO1FBRUQsSUFBSSxDQUFDLFdBQVcsR0FBRyxJQUFJLENBQUM7UUFDeEIsSUFBSSxDQUFDLFlBQVksR0FBRyxJQUFJLENBQUM7UUFFekIsSUFBSSxDQUFDLGtCQUFrQixDQUFDLFlBQVksQ0FBQyxJQUFJLENBQUMsS0FBSyxDQUFDLENBQUMsSUFBSSxDQUFDO1lBQ2xELEtBQUksQ0FBQyxXQUFXLEdBQUcsSUFBSSxDQUFDO1lBQ3hCLEtBQUksQ0FBQyxRQUFRLEdBQUcsS0FBSyxDQUFDO1FBQzFCLENBQUMsQ0FBQyxDQUFDLEtBQUssQ0FBQztZQUNMLEtBQUksQ0FBQyxRQUFRLEdBQUcsSUFBSSxDQUFDO1FBQ3pCLENBQUMsQ0FBQyxDQUFDLE9BQU8sQ0FBQztZQUNQLEtBQUksQ0FBQyxZQUFZLEdBQUcsS0FBSyxDQUFDO1FBQzlCLENBQUMsQ0FBQyxDQUFDO0lBQ1AsQ0FBQztJQUNMLGlDQUFDO0FBQUQsQ0FBQyxBQTdCRCxJQTZCQztBQTdCWSxnRUFBMEIifQ==